<!--
  ~ Copyright (c) by INFODATA-GROUP. All rights reserved.
  ~ No part of this publication may be reproduced, distributed,
  ~ or transmitted in any form or by any means, including photocopying, recording,
  ~ or other electronic or mechanical methods, without the prior written permission of the publisher,
  ~ except in the case of brief quotations embodied in critical
  ~ reviews and certain other noncommercial uses permitted by copyright law.
  ~  author : vhe
  ~  date : 02/03/2021 07:39
  -->

<div class="week">
  @if (showResources()) {
    <infl-calendar-horizontal-resources
      #resourcesComponent
      [resources]="resources()"
      [resourceTitle]="resourceTitle()"
      [heightTitle]="this.numberSection() ? 60 : 90"
      (changeDisplay)="onChangeDisplay()"
    />
  }
  <div class="week-container" [style.width]="weekContainerStyle()">
    <div class="header">
      <div class="header-content">SEMAINE {{ weekNumber() }}</div>
    </div>
    <div class="days">
      @for (day of week; track day.timeStamp; let i = $index) {
        <div
          #daysContent
          class="day section-day-hor"
          [class.current]="day.isToday"
          [class.number-section]="numberSection() && day.isToday"
        >
          @if (!this.numberSection()) {
            <infl-calendar-view-day-by-hour-horizontal
              #days
              [resources]="resources()"
              [onWeek]="true"
              [tasks]="tasks()"
              [outsideDraggingTask]="draggingTask()"
              [start]="start()"
              [end]="end()"
              [resourceLines]="resourceLines"
              [day]="day.date"
              [showResources]="false"
              [dragByOutside]="dragByOutside()"
              [canDrag]="canDrag()"
              [canResize]="canResize()"
              [canSelect]="canSelect()"
              [enable]="enable()"
              [hourDivCount]="hourDivCount()"
              [sectionHeight]="sectionHeight()"
              [cellWidth]="cellWidth()"
              [taskHeight]="taskHeight()"
              [teleworks]="teleworks()"
              (taskUpdate)="taskUpdate.emit($event)"
              (dragTask)="onDragTask($event)"
              (hourSelection)="onHourSelection(days, $event)"
              (hourPreselection)="hourPreselection.emit($event)"
              (clickOnSelection)="onClickOnSelection(day.date, $event)"
              (dblClickOnSelection)="onClickOnSelection(day.date, $event, true)"
              (taskContextMenu)="onRightClick($event)"
              (taskCreation)="taskCreation.emit($event)"
              (taskHover)="taskHover.emit($event)"
              (taskClick)="taskClick.emit($event)"
              (taskDblClick)="taskDblClick.emit($event)"
              (dropOutside)="dropOutside.emit()"
            >
            </infl-calendar-view-day-by-hour-horizontal>
          } @else {
            <infl-calendar-view-day-horizontal
              #days
              [resources]="resources()"
              [onWeek]="true"
              [tasks]="tasks()"
              [outsideDraggingTask]="draggingTask()"
              [startMorning]="start()"
              [endMorning]="endMorning()"
              [startAfternoon]="startAfternoon()"
              [endAfternoon]="end()"
              [resourceLines]="resourceLines"
              [day]="day.date"
              [showResources]="false"
              [dragByOutside]="dragByOutside()"
              [canDrag]="canDrag()"
              [canResize]="canResize()"
              [canSelect]="canSelect()"
              [enable]="enable()"
              [numberSection]="numberSection()"
              [sectionHeight]="sectionHeight()"
              [cellWidth]="sectionWidth()"
              [taskHeight]="taskHeight()"
              [teleworks]="teleworks()"
              (taskUpdate)="taskUpdate.emit($event)"
              (dragTask)="onDragTask($event)"
              (hourSelection)="onHourSelection(days, $event)"
              (hourPreselection)="hourPreselection.emit($event)"
              (clickOnSelection)="onClickOnSelection(day.date, $event)"
              (dblClickOnSelection)="onClickOnSelection(day.date, $event, true)"
              (taskCreation)="taskCreation.emit($event)"
              (taskHover)="taskHover.emit($event)"
              (taskClick)="taskClick.emit($event)"
              (taskDblClick)="taskDblClick.emit($event)"
              (dropOutside)="dropOutside.emit()"
            >
            </infl-calendar-view-day-horizontal>
          }
        </div>
      }
    </div>
  </div>
</div>
